import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import ClientsPage from "@/pages/ClientsPage";
import InvoiceDetailPage from "@/pages/InvoiceDetailPage";
import ReportsPage from "@/pages/ReportsPage";
import DraftsPage from "@/pages/DraftsPage";
import DraftEditorPage from "@/pages/DraftEditorPage";
import ExpensesPage from "@/pages/ExpensesPage";
import SettingsPage from "@/pages/SettingsPage";
import BillingPage from "@/pages/BillingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import SupportPage from "@/pages/SupportPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordPages";

const Protected = ({ children, requireBilling = true }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (requireBilling && user.billing && !user.billing.entitled) return <Navigate to="/billing" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.billing?.is_admin ? children : <Navigate to="/clients" replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<AuthPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/billing" element={<Protected requireBilling={false}><BillingPage /></Protected>} />
            <Route path="/payment/success" element={<Protected requireBilling={false}><PaymentSuccessPage /></Protected>} />
            <Route path="/payment/cancel" element={<Navigate to="/billing" replace />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/clients" element={<ClientsPage />} />
              <Route path="/invoices" element={<Navigate to="/reports" replace />} />
              <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/drafts" element={<DraftsPage />} />
              <Route path="/drafts/:id" element={<DraftEditorPage />} />
              <Route path="/expenses" element={<ExpensesPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/admin" element={<AdminOnly><AdminPage /></AdminOnly>} />
            </Route>
            <Route path="*" element={<Navigate to="/clients" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
